module.exports = __webpack_public_path__ + "assets_1775109859079/img/pic_8.444c4de9.png";